import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { ScrollView, View, Linking } from 'react-native';
import NavigationService from 'NavigationService';
import { Hr, withConfirmationModal, NavigationPicker, TextHeader, Wizard } from 'LocalGluons';
import {
    getInfoListItems,
    isEpisode,
    isLiveTv,
    isRecording,
    isSeason,
    isVod,
    isSeries,
    isRecordingSeries,
    isArchive
} from 'Utils';
import { t } from 'Locale';
import AssetDetail from 'LocalGluons/components/AssetDetail';
import InfoList from 'LocalGluons/components/InfoList';
import { Device } from 'DeviceUtils';
import { withStore, useStore } from 'Store';
import { useNavigation, useRoute } from '@react-navigation/native';
import { CanalplusConsentPopup } from 'LocalGluons/components/CanalplusConsentDialog';
import { PLATFORMS } from 'Options';
import { use } from 'i18next';
import { handleScroll, show } from 'ReduxStore/webMenu';
import { useAppSelector, useAppDispatch } from 'ReduxStore/hooks';
import { withNavigationHelper } from '../../../context/NavigationHelper/withNavigationHelper';
import SeriesList from './SeriesList';
import { withItemUpdater } from './ItemUpdater';
import ButtonsContainer from './components/ButtonsContainer/ButtonsContainer';
import NavigationPickerHeader from '../../../localGluons/components/NavigationPicker/components/NavigationPickerHeader/NavigationPickerHeader';
import {
    getHeaderTitleByItem,
    getPickerItemByType,
    getPickerItems,
    sortEpisodes
} from './detailsUtils';
import ContentWrapper from '../ContentWrapper';
import defaultStyles from './Details.jss';
import useDetailsLogic from './useDetailsLogic';
import PlayButton from './components/PlayButton';
import onAppVoyoContentApproached, { EntitlementsActions } from './voyoDetailsUtils';
import { useNavigationPropsContext } from '../../Navigation/navigationPropsContext';
// item detail component -> note that this is not detail shown from mini-EPG or from player at all.
// It is component representing detail in app itself after click on image of asset from app.

const DetailsPage = (props) => {
    const {
        item,
        // item,
        navigation,
        route,
        mCoreConfig,
        updateItem,
        playerData,
        setCurrentScreen,
        setModalContent,
        deviceStorageState,
        setPlayerData,
        loading,
        setLoading,
        playouts,
        entitlements,
        nativeEntitlements,
        isLowLatency
    } = props;
    const [showConsentsAgain, setShowConsentsAgain] = useState(false);
    const { navigationProps } = useNavigationPropsContext();
    const {
        hasSeriesNavigationPicker,
        scrollViewRef,
        pickerIsDisplayed,
        modelItem,
        hasRecommendedCarousel,
        parentItem,
        buttonsContainerProps,
        seasons,
        episodes,
        previewImage,
        previewHeight,
        handleUpdateItem,
        onPickerSelect,
        navigateToRelated,
        isUserAbleToPlay,
        playContent
    } = useDetailsLogic({
        item,
        navigation,
        mCoreConfig,
        updateItem,
        playerData,
        setCurrentScreen,
        setModalContent,
        deviceStorageState,
        setPlayerData,
        setLoading,
        route
    });
    const dispatch = useAppDispatch();
    const platform = item?.data?.pckg?.platform || item?.data?.platform;
    const isVoyo = item?.data?.pckg?.platform === PLATFORMS.VOYO;
    const isThirdPartyPlatform = Object.values(PLATFORMS).includes(platform);

    useEffect(() => {
        NavigationService.setAppNavigationInstance(navigation);
    }, []);

    const isUpsellSceneExternal =
        entitlements &&
        !entitlements?.entitled &&
        entitlements?.action === EntitlementsActions.UpsellMessage;
    const isVodUpsell =
        nativeEntitlements &&
        !nativeEntitlements?.entitled &&
        nativeEntitlements?.action === EntitlementsActions.UpsellMessage;
    const { appManager } = useStore();
    const [hideRecButton, setHideRecButton] = useState(false);
    const [canalPlusWizard, setCanalPlusWizard] = useState(null);
    const getCanalPlus = useCallback(async () => {
        const {
            backstageConnector: { wizard }
        } = appManager.getApi();
        try {
            const wizardRes = await wizard.fetchWizard('canalplus');
            setCanalPlusWizard(wizardRes);
        } catch (error) {
            console.log(error);
        }
    }, []);

    const canalPlusRedirrect = async () => {
        const {
            thirdPartyAppIds: { canalplus }
        } = mCoreConfig;

        const {
            backstageConnector: { wizard, vod }
        } = appManager.getApi();

        try {
            const { deeplinkUrl, thirdPartyAppId } = await vod.getSmallscreenDeeplink(
                PLATFORMS.CANALPLUS,
                item?.data?.id
            );

            if (Device.isWeb) {
                Linking.openURL(deeplinkUrl);
            }

            if (!Device.isWeb && thirdPartyAppId) {
                try {
                    const isAppInstalled = await Linking.canOpenURL(canalplus);

                    if (isAppInstalled || Device.isWeb) {
                        Linking.openURL(deeplinkUrl);
                    } else {
                        getCanalPlus();
                    }
                } catch (e) {
                    console.log('e', e);
                }
            } else {
                Linking.openURL(deeplinkUrl);
            }
        } catch (e) {
            let errorMessage = '';
            errorMessage = e.errorCode;
            if (errorMessage === 'NO_CONSENT') {
                onCanalplusNoConsent();
            }
        }
    };

    const onCanalplusNoConsent = async () => {
        const {
            backstageConnector: { auth }
        } = appManager.getApi();
        const consentsResponse = await auth.getPartnerConsentsDefinition(PLATFORMS.CANALPLUS);
        if (consentsResponse.success) {
            setModalContent(
                <CanalplusConsentPopup
                    navigation={navigation}
                    setModalContent={setModalContent}
                    onAccept={() => canalPlusRedirrect(item?.data?.id)}
                    setShowConsentsAgain={setShowConsentsAgain}
                    consentsResponse={{
                        popup: consentsResponse.consentPopup,
                        detail: consentsResponse.consentDetail,
                        consents: consentsResponse.consents,
                        item
                    }}
                />
            );
        } else {
            canalPlusRedirrect(item?.data?.id);
        }
    };
    const onVoyoPlay = () => {
        onAppVoyoContentApproached(entitlements, item?.data?.id, playouts, setModalContent);
    };
    const playButton = () => {
        let isAbleToPlay;
        let onPressPlay;
        switch (platform) {
            case PLATFORMS.VOYO:
                isAbleToPlay = !isUpsellSceneExternal;
                onPressPlay = onVoyoPlay;
                break;
            case PLATFORMS.CANALPLUS:
                isAbleToPlay = !isUpsellSceneExternal;
                onPressPlay = canalPlusRedirrect;
                break;
            default:
                isAbleToPlay = isUserAbleToPlay;
                onPressPlay = playContent;
        }
        if ((isVod(item) || isEpisode(item)) && isVodUpsell) {
            isAbleToPlay = false;
        }

        if (nativeEntitlements?.entitled) {
            isAbleToPlay = true;
        }

        if (isSeason(item) || isSeries(item)) {
            onPressPlay = (props) => {
                playContent({ ...props, checkEntitlements: true });
            };
        }

        if (item?.hasBlackout && item?.hasBlackout()) {
            isAbleToPlay = false;
        }

        if (isLowLatency && isArchive(item)) {
            isAbleToPlay = false;
        }

        return (
            <PlayButton
                isUserAbleToPlay={isAbleToPlay}
                onPressPlay={onPressPlay}
                previewHeight={previewHeight}
                previewImage={previewImage}
                item={modelItem}
            />
        );
    };

    useEffect(() => {
        if (showConsentsAgain) {
            onCanalplusNoConsent();
        }
    }, [showConsentsAgain]);

    useEffect(() => {
        if (modelItem?.modelType === 'tv') {
            if (modelItem.channelType === 'VOD') {
                setHideRecButton(true);
            } else {
                setHideRecButton(false);
            }
        }
    }, [modelItem]);

    if (canalPlusWizard) {
        return <Wizard data={canalPlusWizard} close={() => setCanalPlusWizard(null)} />;
    }

    return (
        <ContentWrapper
            onRef={scrollViewRef}
            loading={loading}
            onScroll={(e) => dispatch(handleScroll(e))}
        >
            {!loading && (
                <>
                    {hasSeriesNavigationPicker && (
                        <NavigationPicker
                            isDisplayed={pickerIsDisplayed}
                            selectedItem={getPickerItemByType(modelItem, modelItem.locale)}
                            items={getPickerItems(parentItem, modelItem, modelItem.locale)}
                            onSelect={onPickerSelect}
                        />
                    )}
                    <View scrollIndicatorInsets={{ right: 1 }} style={defaultStyles.container}>
                        <View key="details-first-block" style={defaultStyles.firstBlock}>
                            <View style={defaultStyles.detailContainer}>
                                {playButton()}
                                {Device.isTabletOrWeb && (
                                    // TODO: Move used props inside {...buttonsContainerProps}
                                    <ButtonsContainer
                                        isUpsellSceneExternal={isUpsellSceneExternal}
                                        entitlements={entitlements}
                                        nativeEntitlements={nativeEntitlements}
                                        playouts={playouts}
                                        {...buttonsContainerProps}
                                    />
                                )}
                            </View>
                            <View style={defaultStyles.assetDetailContainer}>
                                <AssetDetail
                                    style={defaultStyles.assetDetail}
                                    item={modelItem}
                                    subtitleStyle={defaultStyles.subtitle}
                                >
                                    {Device.isPhone && !hideRecButton && (
                                        <>
                                            <ButtonsContainer
                                                isUpsellSceneExternal={isUpsellSceneExternal}
                                                entitlements={entitlements}
                                                nativeEntitlements={nativeEntitlements}
                                                playouts={playouts}
                                                isLowLatency={isLowLatency}
                                                {...buttonsContainerProps}
                                            />
                                            <Hr />
                                        </>
                                    )}
                                </AssetDetail>
                                {seasons && (
                                    <SeriesList
                                        titlePrefix={t('COMMON.SEASON')}
                                        navigation={navigation}
                                        listData={seasons}
                                        parentItem={modelItem}
                                        listHeader={t('COMMON.SEASONS')}
                                        onPlayPress={playContent}
                                        updateSeriesDetail={handleUpdateItem}
                                    />
                                )}
                                {episodes && (
                                    <SeriesList
                                        titlePrefix={t('COMMON.EPISODE')}
                                        navigation={navigation}
                                        listData={episodes.sort(sortEpisodes)}
                                        parentItem={modelItem}
                                        listHeader={t('COMMON.EPISODES')}
                                        onPlayPress={playContent}
                                        updateSeriesDetail={handleUpdateItem}
                                    />
                                )}
                                <InfoList
                                    items={getInfoListItems(modelItem, deviceStorageState.language)}
                                />
                            </View>
                        </View>
                        {/* <View key="details-second-block" style={defaultStyles.secondBlock}>
                            {hasRecommendedCarousel && !isVoyo && (
                                <RecommendedMoviesCarousel
                                    testID="related_carousel"
                                    style={defaultStyles.recommendedCarousel}
                                    onMoviePress={navigateToRelated}
                                    item={modelItem}
                                    navigation={navigation}
                                />
                            )}
                        </View> */}
                    </View>
                </>
            )}
        </ContentWrapper>
    );
};

DetailsPage.defaultProps = {
    parentItem: null,
    loading: false,
    playerData: null,
    playouts: null,
    platform: ''
};

DetailsPage.propTypes = {
    item: PropTypes.shape({}),
    navigation: PropTypes.shape({
        state: PropTypes.shape({}),
        addListener: PropTypes.func.isRequired
    }).isRequired,
    mCoreConfig: PropTypes.shape({}).isRequired,
    updateItem: PropTypes.func.isRequired,
    playerData: PropTypes.shape({}),
    setCurrentScreen: PropTypes.func.isRequired,
    setModalContent: PropTypes.func.isRequired,
    deviceStorageState: PropTypes.shape({}).isRequired,
    setPlayerData: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    setLoading: PropTypes.func.isRequired,
    parentItem: PropTypes.shape({}),
    appManager: PropTypes.shape({
        state: PropTypes.shape({})
    }).isRequired
};

const DetailsWithDataStore = withStore(DetailsPage);
const DetailsWithItemUpdater = withItemUpdater(DetailsWithDataStore);
const DetailsWithNavigationHelper = withNavigationHelper(DetailsWithItemUpdater);
const DetailsWithConfirmationModal = withConfirmationModal(DetailsWithNavigationHelper);

const DetailsHeaderTitle = ({ allowFontScaling, tintColor, style, children }) => {
    const route = useRoute();
    const { navigationProps, updateNavigationProps } = useNavigationPropsContext();
    const navigationPickerHeaderIsToggled =
        navigationProps?.navigationPickerHeaderIsToggled || false;
    const parentItem = route.params?.parentId || null;
    const item = navigationProps?.item || null;
    const headerTitle = navigationProps?.headerTitle || route.params?.headerTitle || '';
    const isTvSeriesLike = item && (isLiveTv(item) || isRecording(item)) && parentItem;
    // if (
    //     item &&
    //     (isSeason(item) || isEpisode(item) || isTvSeriesLike || isRecording(item)) /* true */
    // ) {
    //     console.log('RETURN THIS ????');
    //     const currentPickerItem = getPickerItemByType(item, item.locale);
    //     return (
    //         <NavigationPickerHeader
    //             testID={item.slug}
    //             isToggled={Boolean(navigationPickerHeaderIsToggled)}
    //             selectedItemLabel={currentPickerItem.title}
    //             paramsRoute="Details"
    //             onToggle={() => {
    //                 updateNavigationProps({
    //                     navigationPickerHeaderIsToggled: !navigationPickerHeaderIsToggled
    //                 });
    //             }}
    //         />
    //     );
    // }

    return (
        <TextHeader
            testID="header"
            title={headerTitle || (item ? getHeaderTitleByItem(item) : '')}
        />
    );
};

DetailsWithConfirmationModal.DetailsHeaderTitle = DetailsHeaderTitle;

export default DetailsWithConfirmationModal;
